import {
    Box,
    Flex,
}                                from "grid-styled"
import querystring               from "querystring"
import React, {
    Component,
    Fragment,
}                                from "react"
import { connect }               from "react-redux"
import styled                    from "styled-components"
import infraMonitorService       from "../../../api/infraMonitorService"
import {
    ContainerLeft,
    ContainerRight,
    Filter,
    Loader,
    Page,
    Pagination,
    ProjectStatusChart,
    Search,
    Tabs,
}                                from "../../../components/layouts"
import ProjectListBudgetExpChart from "../../../components/layouts/projectBudgetExpChart/projectListBudgetExpChart"
import {
    Heading,
    Text,
}                                from "../../../components/styled"
import { images }                from "../../../config/index"
import {
    getList,
    getListSuccess,
    setFilters,
}                                from "../../../infraMonitor/actions"
import {
    commonLocalization,
    number,
    projectsLocalization,
}                                from "../../../localization"
import FilterTags                from "./filterTags"
import ProjectProgress           from "./partials/project-progress"
import ProjectTable              from "./partials/project-table"

class ProjectList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedTab: "data",
            currentPage: props.pagination.current_page,
            projects: [],
            searchValue: "",
            selectedYear: props.fiscalYear,
            removedFilter: "",
        }

        this.municipality = props.municipality
    }

    componentDidMount() {
        const { getDataList, location, fiscalYear } = this.props;

        const rawQueryParams = location.search
        ? querystring.parse(location.search.replace(/^\?/, ""))
        : {};

        const normalizedQueryParams = {};
        Object.keys(rawQueryParams).forEach((key) => {
        normalizedQueryParams[key] = Array.isArray(rawQueryParams[key])
            ? rawQueryParams[key][0]
            : rawQueryParams[key];
        });

        const requestParams = {
        ...normalizedQueryParams,
        "fiscal-year": fiscalYear,
        };

        getDataList(requestParams, this.municipality);
    }

    UNSAFE_componentWillReceiveProps(prevProps) {
        if (this.state.selectedYear !== prevProps.fiscalYear) {
            this.setState(
                {
                    selectedYear: prevProps.fiscalYear,
                },
                () => {
                    this.setQueryString({
                        ...prevProps.filters,
                        "fiscal-year": prevProps.fiscalYear,
                    })
                    this.props.getDataList(
                        {
                            ...prevProps.filters,
                            "fiscal-year": prevProps.fiscalYear,
                        },
                        this.municipality,
                    )
                },
            )
        }
    }

    onTabChange = val => {
        this.setState({ selectedTab: val })
    }

    setQueryString = filters => {
        const query = Object.keys(filters).length
            ? `&${querystring.stringify(filters)}`
            : ""

        this.props.history.push({
            search: `page=1${query}`,
        })
    }

    filterData = filters => {
        const { getDataList } = this.props
        const selectedFilters = { ...filters, search: this.state.searchValue }
        this.setQueryString(selectedFilters)
        getDataList(selectedFilters, this.municipality)
    }

    removeFilter(key) {
        const { filters, getDataList } = this.props

        let filtersResult = {
            ...filters,
            [key]: "",
        }

        // remove the project_budget_subprogram as well when project_budget_program is removed
        if (key === "project_budget_program") {
            filtersResult = {...filtersResult, project_budget_subprogram: ''}
        }

        this.setQueryString(filtersResult)
        getDataList(filtersResult, this.municipality)
        this.setState({removedFilter: key})
    }

    resetRemovedFilterState = () => {
        this.setState({removedFilter: ''});
    }

    onSearchChange = val => {
        const { getDataList, filters } = this.props

        this.setState(
            {
                searchValue: val,
            },
            () => {
                this.setQueryString({ ...filters, search: val })
                getDataList({ ...filters, search: val }, this.municipality)
            },
        )

    }

    sortByType = (title, type) => {
        const { getDataList, filters } = this.props
        getDataList(
            { ...filters, sort_by: title, order_by: type },
            this.municipality,
        )
    }

    handleChangePagination = pageIndex => {
        const { getDataListForPagination, filters } = this.props

        const query = querystring.parse(
            this.props.location.search.replace("?", ""),
        )

        query.page = pageIndex.selected + 1
        this.props.history.push({
            search: `?${querystring.stringify(query)}`,
        })

        getDataListForPagination({ ...filters, page: pageIndex.selected + 1 }, this.municipality)
    }

    biddersTitle(ward) {
        const { selectedLanguage } = this.props
        const wardValue = number(ward)

        const { bidders } = projectsLocalization[selectedLanguage]

        if (wardValue === "") {
            return <Text.span>{bidders}</Text.span>
        }

        if (selectedLanguage === "en") {
            return (
                <Text.span>
                    {bidders} for <strong>ward {wardValue}</strong>
                </Text.span>
            )
        }
        return (
            <Text.span>
                <strong>वडा {wardValue}</strong> का लागि {bidders}
            </Text.span>
        )
    }

    navigateToProject = status => {
        const { getDataList, filters } = this.props
        let appliedStatus = ""
        if (status !== "total_projects") {
            appliedStatus = status
        }

        const selectedFilters = { ...filters, status: appliedStatus }
        this.setQueryString(selectedFilters)
        getDataList(selectedFilters, this.municipality)
    }

    render() {
        const { selectedTab } = this.state

        const {
            pagination,
            fetching,
            selectedLanguage,
            projects,
            filters,
            stats,
            loading,
            municipality,
        } = this.props

        const { searchPlaceholder } = projectsLocalization[selectedLanguage]

        const { dataNotAvailable } = commonLocalization[selectedLanguage]

        return (
            <React.Fragment>
                {fetching && <Loader/>}
                <Page className="project-list" lang={selectedLanguage}>
                    <ContainerLeft>
                        <TopWrap>
                            <Search
                                onSearchChange={this.onSearchChange}
                                placeholder={searchPlaceholder}
                            />
                            <Flex className="top-right-wrap">
                                <Box>
                                    {!loading && (
                                        <Filter
                                            filterData={this.filterData}
                                            municipality={municipality}
                                            removedFilter={this.state.removedFilter}
                                            resetRemovedFilterState={this.resetRemovedFilterState}
                                        />
                                    )}
                                </Box>
                                <Box>
                                    <Tabs firstTab={{ value: "data", className: "data" }}
                                          secondTab={{ value: "progress", className: "progress" }}
                                          selectedTab={this.state.selectedTab}
                                          onTabChange={this.onTabChange}/>
                                </Box>
                            </Flex>
                        </TopWrap>
                        <FilterTags
                            filters={filters}
                            removeFilter={key => this.removeFilter(key)}
                        />
                        {selectedLanguage === "en" ? (
                            <WardProjectList>
                                {filters.ward === "" ? (
                                    <Heading.h2>Project list for all wards</Heading.h2>
                                ) : (
                                    <Heading.h2>
                                        Project list for <strong>ward {filters.ward}</strong>
                                    </Heading.h2>
                                )}
                            </WardProjectList>
                        ) : (
                            <WardProjectList>
                                {filters.ward === "" ? (
                                    <Heading.h2>सबै वडा का लागि कूल परियाेजनाहरु</Heading.h2>
                                ) : (
                                    <Heading.h2>
                                        <strong>वडा {number(filters.ward)}</strong> का लागि कूल
                                                                                    परियाेजनाहरु
                                    </Heading.h2>
                                )}
                            </WardProjectList>
                        )}
                        <Fragment>
                            {selectedTab === "data" && (
                                <TableWrap>
                                    {!!projects.length && (
                                        <ProjectTable
                                            sortByType={(title, type) => this.sortByType(title, type)}
                                            projects={projects}
                                        />
                                    )}
                                    {!projects.length && !fetching && (
                                        <div className="data-not-available">
                                            <img
                                                src={images.dataNotAvailable}
                                                alt="data not available"
                                            />
                                            <Text.span lighter>{dataNotAvailable}</Text.span>
                                        </div>
                                    )}
                                </TableWrap>
                            )}
                            {selectedTab !== "data" && (
                                <TableWrap>
                                    {!!projects.length && (
                                        <ProjectProgress
                                            sortByType={(title, type) => this.sortByType(title, type)}
                                            projects={projects}
                                        />
                                    )}
                                    {!projects.length && !fetching && (
                                        <div className="data-not-available">
                                            <img
                                                src={images.dataNotAvailable}
                                                alt="data-not-available"
                                            />
                                            <Text.span lighter>{dataNotAvailable}</Text.span>
                                        </div>
                                    )}
                                </TableWrap>
                            )}
                        </Fragment>
                        {projects.length && !fetching ? (
                            <Pagination
                                pagination={pagination}
                                handleChangePagination={this.handleChangePagination.bind(this)}
                            />
                        ) : (
                            ""
                        )}
                    </ContainerLeft>
                    <ContainerRight>
                          <div className="chart-block--status">
                              <Fragment>
                                  <ProjectStatusChart
                                      projects={projects}
                                      wardValue={filters.ward}
                                      stats={stats}
                                      total={pagination.total}
                                      navigateToProject={this.navigateToProject}
                                  />
                              </Fragment>
                              <ProjectListBudgetExpChart stats={stats}/>
                          </div>
                    </ContainerRight>
                </Page>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    projects: state.infraMonitor.projects,
    pagination: state.infraMonitor.pagination,
    stats: state.infraMonitor.stats,
    fetching: state.infraMonitor.fetching,
    filters: state.infraMonitor.filters,
    selectedLanguage: state.localizationReducers.selectedLanguage,
    fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
    loading: state.staticData.loading,
})

const mapDispatchToProps = dispatch => {
    const getProjectList = (filters, municipality) => {
        dispatch(getList())
        infraMonitorService
            .getProjectList(filters, municipality.title_en)
            .then(response => {
                const { data, metadata } = response
                dispatch(
                    getListSuccess({
                        projects: data,
                        pagination: metadata.pagination,
                        stats: metadata.stats,
                    }),
                )
            })
    }
    return {
        getDataList: (filters, municipality) => {
            getProjectList(filters, municipality)
            dispatch(setFilters(filters))
        },

        getDataListForPagination: (filters, municipality) => {
            getProjectList(filters, municipality)
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProjectList)

const TopWrap = styled.div`
  @media all and (min-width: 600px) and (max-width: 991px),
    (min-width: 1200px) {
    display: flex;
    justify-content: space-between;
    margin: 0;
  }
  .top-right-wrap {
    align-items: center;
    justify-content: space-between;
    width: 100%;
    > div:first-child {
      margin-right: 10px;
    }
    @media all and (min-width: 600px) and (max-width: 991px),
      (min-width: 1200px) {
      width: 46%;
    }
  }
`

const TableWrap = styled.div`
  .status {
    border-radius: 11px;
    padding: 4px 10px;
  }
  .status--running {
    background-color: ${props => props.theme.sec.blue};
  }
  
  .status--completed {
    background-color: ${props => props.theme.sec.green};
  }
  
  .status--tendered {
    background-color: ${props => props.theme.sec.gray};
  }
  
  .status--cancelled {
    background-color: ${props => props.theme.sec.pink};
  }
  
  .status--not-started {
    background-color: ${props => props.theme.sec.red};
    white-space: nowrap;
  }
  .data-not-available {
    margin-top: 100px;
    text-align: center;
    span {
      display: block;
      font-size: 16px;
      margin-top: 20px;
    }
  }

  .ward-num {
    li {
      display: inline-block;
      & + li:before {
        content: ",";
        margin-right: 4px;
      }
    }
  }

  .progress__bar--line {
    align-items: center;
    display: flex;
    font-size: 10px;
  }

  .progress__total {
    background-color: ${props => props.theme.dark.charcoalGrey};
    border-radius: 8px;
    height: 8px;
    margin-right: 5px;
    width: 82%;
    overflow: hidden;
    & + .progress__total {
      margin-top: 10px;
    }
  }

  .progress {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    display: block;
    height: 8px;
  }

  .progress__physical {
    background-color: ${props => props.theme.primary.pissYellow};
  }

  .progress__financial {
    background-color: ${props => props.theme.primary.white};
  }

  .progress__total--physical,
  .progress__total--financial {
    border-radius: 6px;
  }

  .title__progress {
    font-size: 13px;
    margin: 0 3px;
    padding-left: 10px;
    position: relative;
    text-transform: none;
    &:before {
      border-radius: 50%;
      content: "";
      height: 6px;
      left: 0;
      position: absolute;
      width: 6px;
      top: 5px;
    }
    &--physical:before {
      background-color: ${props => props.theme.primary.pissYellow};
    }
    &--financial:before {
      background-color: ${props => props.theme.primary.white};
    }
  }
`

const WardProjectList = styled.div`
  h2 {
    font-size: clamp(1.5rem, 3.7vw, 2rem);
    margin: 30px 0 15px;
  }
`




// WEBPACK FOOTER //
// ./src/pages/project/list/list.js